import React from 'react';

type Props = {
  className?: string
  children: any
}

function ChdButtonGroup({ className, children }: Props) {
  return (
    <div className={`${className} flex flex-wrap justify-between gap-4`}>
      {children}
    </div>
  );
}

ChdButtonGroup.defaultProps = {
  className: '',
};

export default ChdButtonGroup;
